import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Reorder,
  Resize,
  Sort,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { useEffect, useState, useRef } from 'react';
import { BiX } from 'react-icons/bi';
import { BsCheck2 } from 'react-icons/bs';
import {all_information, GetErpTypeFromConfig, loadingShow} from '../App';
import { getSelectedOrgIds } from '../utils/orgCodeMap';
import {
  AddGlobalFilter,
  DeleteGlobalFilter,
  EditGlobalFilter,
  getGlobalFilter,
} from '../services/GlobalFilter/GlobalFilterServices';
import Message from '../utils/Message/Message';
import { SyncFullMexGlobalFilterOperations } from '../services/MexServices/GlobalFilter/MexGlobalFilterService';
import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { getMyOrganizations } from '../services/Users/Users';
import { invalidateGlobalFilterCache } from './GlobalDropDown';

let dropDownListObjectColor: ColorPickerComponent = new ColorPickerComponent(
  {}
);
var gridWorkordersFilterObj: GridComponent = new GridComponent({});
let isAdd: boolean = false;
let id: number = 0;
let isRenderFinish: boolean = false;
var dropdownnEnabled: SwitchComponent = new SwitchComponent({});
interface IProps {
  query: string;
  columns: Array<any>;
  enableOrgEdit?: boolean;
}
let orgDropDown: DropDownListComponent | null = null;
let organizations: { id: number; code: string }[] = [];
const GlobalFilterComponent = ({ columns, query, enableOrgEdit }: IProps) => {
  const ERP_TYPE = GetErpTypeFromConfig();
  const erpTypeName = 'MEX';
  const validationRule: Object = { required: true };
  const [datasource, setDatasource] = useState([]);
  const [orgReady, setOrgReady] = useState(!enableOrgEdit);
  const FilterOptions: FilterSettingsModel = { type: 'Menu' };
  const editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    showDeleteConfirmDialog: true,
  };
  const pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 50,
    pageCount: 8,
    pageSizes: false,
  };

  const toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    {
      text: 'Sync All',
      tooltipText: 'Sync All',
      id: 'sync_all',
      visible: false
      /* visible: ERP_TYPE === erpTypeName ? true : false, */
    },
    'ColumnChooser',
    'ExcelExport',
  ];
  const toolbarClick = (args: any) => {
    if (args.item.id === 'refresh') {
      console.log('refresh',query);
      getGlobalFilterParam(query);
    }
    if (args.item.id === 'sync_all') {
      console.log('sync_all',args);
      let section = query ? query.split('$')[1] : null;
      loadingShow(true, 'Waiting for sync operations...');
      SyncFullMexGlobalFilterOperations(section)
        .then((result) => {
          if (result.status === 200) {
            loadingShow(false);
            Message.success('Synced successfully...');
            Message.success('Please press the Refresh Button...');
          }
        })
        .catch((err) => {
          loadingShow(false);
          Message.error('We are unable to process your request.');
        });
    }
    if (
      gridWorkordersFilterObj &&
      args.item.id === 'gridEventStatus_excelexport'
    ) {
      gridWorkordersFilterObj.excelExport();
    }
  };
  const notifyFilterChanged = () => {
  invalidateGlobalFilterCache(query);
  window.dispatchEvent(new CustomEvent('globalFilterChanged', { detail: { query } }));
  };
  let color: string = '';
  const actionBegin = (args: any) => {
    if (query === 'tradeplanner$type') {
      if (dropDownListObjectColor !== undefined) {
        color = dropDownListObjectColor?.value;
      }
    }
    if (args.action === 'add') {
      isAdd = true;
      addGlobalFilterParamType(args.data);
    } else if (args.action === 'edit') {
      isAdd = false;
      addGlobalFilterParamType(args.data);
    } else if (args.requestType === 'delete') {
      id = args.data[0].id;
      deleteAssetType();
    }
  };
  const deleteAssetType = () => {
    const obj = {
      id: id,
    };
    DeleteGlobalFilter(obj)
      .then(() => {
        loadingShow(false);
        Message.success('Successfully');
        getGlobalFilterParam(query);
        notifyFilterChanged();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  };
  const rawDataRef = useRef<any[]>([]);
  const isMountedRef = useRef<boolean>(true);
  const gridRef = useRef<GridComponent | null>(null);

  const filterByActiveOrgs = (items: any[], activeIds: number[]) => {
    if (!activeIds || activeIds.length === 0) {
      return items;
    }
    return items.filter((item: any) => {
      const ids: number[] =
        Array.isArray(item.organization_ids) && item.organization_ids.length
          ? item.organization_ids.map(Number)
          : item.organization_id != null
          ? [Number(item.organization_id)]
          : [];
      if (ids.length === 0) {
        return true;
      }
      return ids.some((orgId) => activeIds.includes(orgId));
    });
  };

  const getGlobalFilterParam = (queryParam: string, targetOrgIds?: number[]) => {
    getGlobalFilter(queryParam)
      .then((res) => {
        loadingShow(false);
        if (isMountedRef.current) {
          const mapped = (res.data || []).map((el: any) => {
            return { ...el, name: el.value };
          });
          rawDataRef.current = mapped;
          const currentOrgIds = targetOrgIds ?? getSelectedOrgIds();
          setDatasource(filterByActiveOrgs(mapped, currentOrgIds));
        }
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(err.response.data);
          Message.error(err.response.status);
          Message.error(err.response.headers);
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  };
  const addGlobalFilterParamType = (objCommer: any) => {
    loadingShow(true, 'Adding');
    const selectedOrgId = enableOrgEdit ? orgDropDown?.value : null;
    const selectedOrgIds: number[] =
      selectedOrgId != null && selectedOrgId !== '' ? [Number(selectedOrgId)] : [];
    const obj = {
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      organization_ids: selectedOrgIds,
      description: objCommer.description,
      value: objCommer.name,
      code: objCommer.code,
      filter_type: query.split('$')[1],
      filter_section: query.split('$')[0],
      color: dropDownListObjectColor?.value,
      id: objCommer.id,
      isEnabled: dropdownnEnabled.checked,
      alias: objCommer.alias,
      creation_date: new Date(),
      note_id: objCommer.id,
    };

    if (isAdd) {
      AddGlobalFilter(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          getGlobalFilterParam(query);
          notifyFilterChanged();
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditGlobalFilter(obj)
        .then(() => {
          loadingShow(false);
          Message.success('Successfully');
          getGlobalFilterParam(query);
          notifyFilterChanged();
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  };
  const isTrackExpiryTemplate = (args: any) => {
    let isEnabled = args.isEnabled;
    return (
      <div>
        {isEnabled ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  const isTrackExpiryTemplateEditing = (args: any) => {
    return (
      <SwitchComponent
        checked={args.isEnabled}
        ref={(scope: SwitchComponent) => (dropdownnEnabled = scope)}
      />
    );
  };
  useEffect(() => {
    isMountedRef.current = true;
    isRenderFinish = true;
    loadingShow(true, 'process will take some time, please wait...');

    const init = async () => {
      if (enableOrgEdit && all_information?.token) {
        try {
          const res: any = await getMyOrganizations(all_information.token);
          organizations = (res?.data ?? []).map((o: any) => ({
            id: o.organization_id,
            code: o.organization_code || `Org #${o.organization_id}`,
          }));
        } catch (e) {
          console.error('Failed to load organizations', e);
        }
      }
      if (isMountedRef.current) {
        setOrgReady(true);
        getGlobalFilterParam(query);
      }
    };
    init();

    const handleOrgChange = (e: any) => {
      const newOrgIds: number[] = e?.detail?.selectedOrgIds ?? getSelectedOrgIds();
      if (rawDataRef.current.length > 0) {
        setDatasource(filterByActiveOrgs(rawDataRef.current, newOrgIds));
      }
      getGlobalFilterParam(query, newOrgIds);
    };

    window.addEventListener('organizationChanged', handleOrgChange);

    return () => {
      isMountedRef.current = false;
      isRenderFinish = false;
      window.removeEventListener('organizationChanged', handleOrgChange);
    };
  }, [query]);

  const colorEditTemplate = (args: any) => {
    return (
      <ColorPickerComponent
        value={args.color}
        ref={(scope: any) => (dropDownListObjectColor = scope)}
      />
    );
  };
  const colorTemplate = (args: any) => (
    <div style={{
      width: 20, height: 20, borderRadius: 3,
      backgroundColor: args.color,
      margin: '5px 0px 5px 8px',
    }} />
  );

  const orgTemplate = (args: any) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, padding: '2px 0' }}>
    {(args.organization_ids ?? []).map((id: number) => (
      <span key={id} style={{ backgroundColor: '#4c5b6e', borderRadius: 2, paddingLeft: '6px', paddingRight: '6px', fontSize: 14, fontWeight: 500, paddingTop: '2px', paddingBottom: "0px" }}>
        {organizations.find((o) => o.id === id)?.code ?? id}
      </span>
    ))}
  </div>
);

const orgEditTemplate = (args: any) => {
  const defaultOrgIds = getSelectedOrgIds();
  const initialValue: number | null = args.organization_ids?.length
    ? Number(args.organization_ids[0])
    : (defaultOrgIds.length
        ? Number(defaultOrgIds[0])
        : (all_information.company_id != null ? Number(all_information.company_id) : null));

  return (
    <DropDownListComponent
      dataSource={organizations}
      fields={{ text: 'code', value: 'id' }}
      value={initialValue as any}
      placeholder='Select organization'
      popupHeight='250px'
      ref={(s: any) => (orgDropDown = s)}
    />
  );
};

  return (
    <div className='main-content-order-request'>
      <GridComponent
        editSettings={editOptions}
        toolbar={toolbarOptions}
        dataSource={datasource}
        height={'calc(-270px + 100vh)'}
        ref={(g: GridComponent) => {
          gridRef.current = g;
          gridWorkordersFilterObj = g;
        }}
        filterSettings={FilterOptions}
        allowFiltering={true}
        allowPaging={true}
        pageSettings={pageOptions}
        dataBound={() => {}}
        showColumnMenu={true}
        allowResizing={true}
        allowGrouping={true}
        allowExcelExport={true}
        allowSorting={true}
        groupSettings={{ showGroupedColumn: true }}
        showColumnChooser
        toolbarClick={toolbarClick.bind(this)}
        actionBegin={actionBegin.bind(this)}
        gridLines='Both'
        allowReordering={true}
      >
        <ColumnsDirective>
            <ColumnDirective
              field='color'
              headerText='#'
              textAlign='Left'
              width={35}
              visible={query === 'tradeplanner$type'}
              template={colorTemplate.bind(this)}
              editTemplate={colorEditTemplate.bind(this)}
            />
          {columns.map((el) => {
            return (
              <ColumnDirective
                field={el.field}
                headerText={el.Text.replaceAll('_', ' ')}
                textAlign='Left'
                validationRules={el.field === 'code' ? undefined : validationRule}
                key={el.field + Math.random()}
              />
            );
          })}
          {enableOrgEdit && orgReady && (
            <ColumnDirective
              field='organization_ids'
              headerText='Organization'
              
              allowFiltering={false}
              allowSorting={false}
              allowGrouping={false}
              template={orgTemplate}
              editTemplate={orgEditTemplate}
            />
          )}
          <ColumnDirective
            field='isEnabled'
            headerText='Enabled'
            width={70}
            template={isTrackExpiryTemplate.bind(this)}
            editTemplate={isTrackExpiryTemplateEditing.bind(this)}
          />
        </ColumnsDirective>
        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            Page,
            ColumnChooser,
            ExcelExport,
            ColumnMenu,
            Resize,
            Sort,
            Group,
            Reorder,
          ]}
        />
      </GridComponent>
    </div>
  );
};

export default GlobalFilterComponent;
